module.exports = __webpack_public_path__ + "img/banner_1.e293f3fc.jpg";